export const defaultApiState = {
  loading: false,
  success: false,
  error: null,
};
